import { Link } from '@remix-run/react'
import RecipeSmallCard from './RecipeSmallCard.tsx'

export default function RecipeList({ recipes, showUser }) {
	return (
		<div className="mx-auto w-full px-0">
			<ul className="row grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 lg:gap-x-6 xl:gap-x-8">
				{recipes.map(recipe => {
					const { id, owner, slug, title } = recipe
					return (
						<li
							key={id}
							className="relative flex-col items-stretch transition-opacity focus-within:ring-2 focus-within:ring-secondary-dark focus-within:ring-offset-2 focus-within:ring-offset-gray-100 hover:opacity-80"
						>
							<Link
								to={`/${owner.username}/recipes/${slug}`}
								className="group inset-0 mt-auto h-full focus:outline-none"
								prefetch="intent"
							>
								<span className="sr-only">View recipe for {title}</span>
								<RecipeSmallCard recipe={recipe} showUser={showUser} />
							</Link>
						</li>
					)
				})}
			</ul>
		</div>
	)
}
